import io from "socket.io-client";
import { electronConstants, wsDomain } from "../constant";

class SocketConnection {
  constructor(token) {
    this.token = token;
    this.reconnectAttemptsCount = 0;
    this.disconnectHandlers = [];
    this.connectTime = 0;

    this.socket = io(wsDomain, {
      auth: { token },
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });

    this.socket.on("connect", () => {
      console.log("Connected to WebSocket server");
      this.reconnectAttemptsCount = 0;

      if (this.connectTime > 0) {
        this.connectTime = 0;
        window.location.replace(window.location.href);
      }
    });

    this.socket.on("connect_error", (error) => {
      console.log("WebSocket connection error:", error);
      this.reconnectManually();
    });

    this.socket.on("disconnect", () => {
      console.log("Disconnected from WebSocket server");
      this.handleDisconnect();
    });
  }

  reconnectManually() {
    if (!this.socket.connected && this.reconnectAttemptsCount < 10) {
      console.log(
        "Trying to reconnect manually..." +
          this.reconnectAttemptsCount +
          " times"
      );
      this.reconnectAttemptsCount++;
      this.connectTime++;
      this.socket.connect();
      return;
    }

    if (this.reconnectAttemptsCount >= 10) {
      console.log("Reconnect failed after 10 attempts");
      this.disconnect();
      this.handleDisconnect();
      if (window.electron?.sendToMain) {
        window.electron.sendToMain(electronConstants.LOG_OUT_STEAM);
      }
    }
  }

  handleDisconnect() {
    if (window.electron?.sendToMain) {
      window.electron.sendToMain(electronConstants.LOG_OUT_STEAM);
    }

    this.disconnectHandlers.forEach((handler) => {
      try {
        handler();
      } catch (error) {
        console.log("Error executing disconnect handler:", error);
      }
    });
  }

  onDisconnect(handler) {
    if (typeof handler === "function") {
      this.disconnectHandlers.push(handler);
    }
  }

  removeDisconnectHandler(handler) {
    const index = this.disconnectHandlers.indexOf(handler);
    if (index > -1) {
      this.disconnectHandlers.splice(index, 1);
    }
  }

  on(eventName, callback) {
    if (!this.socket) return;
    this.socket.on(eventName, callback);
  }

  emit(eventName, data, callback) {
    if (!this.socket) return;
    if (typeof callback === "function") {
      this.socket.emit(eventName, data, callback);
    } else {
      this.socket.emit(eventName, data);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  static ensureInstance() {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      if (SocketConnection.instance) {
        SocketConnection.instance.disconnect();
        SocketConnection.instance = null;
      }
      return null;
    }

    if (
      !SocketConnection.instance ||
      SocketConnection.instance.token !== token
    ) {
      if (SocketConnection.instance) {
        SocketConnection.instance.disconnect();
      }
      SocketConnection.instance = new SocketConnection(token);
    }

    return SocketConnection.instance;
  }

  static destroyInstance() {
    if (SocketConnection.instance) {
      SocketConnection.instance.disconnect();
      SocketConnection.instance = null;
    }
  }
}

SocketConnection.instance = null;

export const socket = {
  on(eventName, callback) {
    const instance = SocketConnection.ensureInstance();
    if (!instance) return;
    instance.on(eventName, callback);
  },
  emit(eventName, data, callback) {
    const instance = SocketConnection.ensureInstance();
    if (!instance) return;
    instance.emit(eventName, data, callback);
  },
  disconnect() {
    SocketConnection.destroyInstance();
  },
  onDisconnect(handler) {
    const instance = SocketConnection.ensureInstance();
    if (!instance) return;
    instance.onDisconnect(handler);
  },
  removeDisconnectHandler(handler) {
    const instance = SocketConnection.instance;
    if (!instance) return;
    instance.removeDisconnectHandler(handler);
  },
};
